import { ControlType } from "../../../base/types";
import { IProperty } from "../../../base/models";
import { Registry } from "../../../base/register";
import { useState } from "react";

export const useGetControlProperties = () => {
    const [properties, setProperties] = useState<IProperty[]>([]);

    const getProperties = (type: ControlType) => {
        const item = Registry.getControlByType(type);
        if (item) {
            setProperties(item?.properties || []);
        } else {
            console.error(`Properties not implemented for ${type}`);
            setProperties([]);
        }
    }

    return { getProperties, properties }
}
